import React, {useState, Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Row,
  Col,
  Container,
  Input,
  UncontrolledButtonDropdown,
  DropdownItem,
  FormGroup
} from "reactstrap";
import DataTable from "react-data-table-component";
import { CustomText, EstadoLista } from "../../Utility/CustomList/index";
import * as Icon from "react-feather";

const List = ({ allData, Actions, One, toggleModalCambio }) => {
  const [searchValue, setSearchValue] = useState(""),
    [filteredData, setFilteredData] = useState([]),
    handleFilter = (e) => {
      const value = e.target.value;
      let updatedData = [];
      setSearchValue(value);

      if (value.length) {
        updatedData = allData.filter((item) => {
          const startsWith =
            item.nombre.toLowerCase().startsWith(value.toLowerCase()) ||
            item.noWare.toLowerCase().startsWith(value.toLowerCase());
          const includes =
            item.nombre.toLowerCase().startsWith(value.toLowerCase()) ||
            item.noWare.toLowerCase().startsWith(value.toLowerCase());

          if (startsWith) {
            return startsWith;
          } else if (!startsWith && includes) {
            return includes;
          } else return null;
        });
        setFilteredData(updatedData);
        setSearchValue(value);
      }
    };

  const Columns = [
    {
      sortable: true,
      name: "Cliente",
      column: "nombre",
      center: true,
      cell: (row) => CustomText(row["nombre"]),
    },
    {
      name: "WareHouse",
      column: "noWare",
      center: true,
      cell: (row) => CustomText(row["noWare"]),
    },
    {
      name: "Tracking",
      column: "tracking",
      center: true,
      cell: (row) => CustomText(row["tracking"]),
    },
    {
      name: "Estado",
      column: "estado",
      center: true,
      width: "200px",
      cell: (row) => <EstadoLista row={row} />,
    },
    {
      name: "Acciones",
      column: "id",
      sortable: true,
      center: true,
      cell: (row) => (
        <UncontrolledButtonDropdown>
          <DropdownItem onClick={() => One(row, 3)}>
            <Icon.Edit className="mr-2" size={15} />
          </DropdownItem>
          <DropdownItem onClick={() => toggleModalCambio(row,1)}>
            <Icon.Info className="mr-2" size={15} />
          </DropdownItem>
        </UncontrolledButtonDropdown>
      ),
    },
  ];

  return (
    <div className="list">
      <Row>
            <Col className='justify-content-end mt-1' md='4' sm='12'>
                    <FormGroup>
                        <Input
                            className='dataTable-filter mb-50'
                            type='text'
                            bsSize='md'
                            placeholder={`Buscar`}
                            id='search-input'
                            value={searchValue}
                            onChange={handleFilter}
                        />
                    </FormGroup>
                </Col>
            </Row>
      <Row>
        <Container>
          <DataTable
            // dense
            sortable
            noHeader
            highlightOnHover
            pagination
            data={searchValue.length ? filteredData : allData}
            columns={Columns}
            className="table-responsive"
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            paginationComponentOptions={{
              rowsPerPageText: "",
              rangeSeparatorText: "",
            }}
            noDataComponent="Sin Registros"
          />
        </Container>
      </Row>
    </div>
  );
};

export default List;
